import React, { Component } from "react";
import { Link } from "react-scroll";
import { connect } from "react-redux";
import { cloneDeep } from "lodash";
import "./index.less";
const SCROLL_DURATION = 500;
const tabActiveClass = 'active';
class TabsLink extends Component {
	constructor(props, context) {
		super(props, context);
		window.previousPageGroup = this.previousPageGroup;
		window.nextPageGroup = this.nextPageGroup;
		this.state = {
			nextPage: false,
			nowPosition: 0, //当前位置
			times: 1, //可点击下一页的次数
			nextPageIcon: false, //下一页是否可点击状态颜色
			previousPageIcon: false, //前一页是否可点击状态颜色
			isVisiblePage: false, //是否显示分页
		};
	}
	//创建li
	createTabsLink = () => {
		const { editable, groups } = this.props;
		const lastLink = groups.find((item, index) => index === groups.length - 1);
		const { nowPosition, nextPage, times } = this.state;
		return groups.map((item, index) => {
			let { pk_app_group, groupname } = item;
			return (
				<li
					key={pk_app_group}
					className={editable && 'anchor'}
					style={
						nextPage && index === 0 && times > 1
							? { marginLeft: `-${nowPosition}%` }
							: {}
					}>
					<Link
						activeClass={tabActiveClass}
						to={pk_app_group}
						offset={editable ? -20 : 0}
						spy={true}
						smooth={true}
						duration={SCROLL_DURATION}
						containerId={editable?'ncWorkbenchHomeEditPage':'ncWorkbenchHomePage'}
						onClick={this.handleLinkClick}
						onSetActive={this.handleSetActive.bind(this, lastLink && lastLink.pk_app_group)}
					>
						{groupname}
						<span />
					</Link>
				</li>
			);
		});
	};
	//click前一步
	previousPageGroup = () => {
		let totalWidth = this.refs.refTabs.offsetWidth; //显示宽度
		let displayWidth = this.refs.refUl.offsetWidth; //ul总宽度
		let numPage = displayWidth / totalWidth;
		let clickNum = Math.ceil(numPage);
		let liMarginLeftVal = ((totalWidth - 40) / displayWidth) * 100; //计算偏移量
		if (this.state.nowPosition < 1) {
			this.setState({
				times: 1,
			});
			return;
		}
		//前一页是否允许点击状态
		if (this.state.times == 1) {
			this.setState({
				previousPageIcon: false,
			});
			return;
		}
		this.setState({
			times: this.state.times - 1,
			nowPosition:
				this.state.nowPosition - liMarginLeftVal < 0.01
					? 0
					: this.state.nowPosition - liMarginLeftVal,
			//前一页最后的状态必须用这个判断
			nextPageIcon: true,
		});
	};
	//click下一步
	nextPageGroup = () => {
		let totalWidth = this.refs.refTabs.offsetWidth;
		let displayWidth = this.refs.refUl.offsetWidth;
		let numPage = displayWidth / totalWidth;
		//不满足分页条件返回
		if (numPage < 1.01) {
			return;
		} else {
			//偏移量次数取整
			let clickNum = Math.ceil(numPage);
			if (this.state.times < clickNum) {
				this.setState({
					times: this.state.times + 1,
				});
			} else {
				return;
			}
			if (clickNum - this.state.times <= 1) {
				this.setState({
					nextPageIcon: false,
				});
			}
		}
		//计算翻页的偏移量
		let liMarginLeftVal = ((totalWidth - 40) / displayWidth) * 100;
		this.setState({
			nextPage: true,
			nowPosition: this.state.nowPosition + liMarginLeftVal,
			previousPageIcon: true,
		});
	};
	//监听屏幕窗口大小的变化
	screenChange = () => {
		let totalWidth = this.refs.refTabs.offsetWidth;
		let displayWidth = this.refs.refUl.offsetWidth;
		let numPage = displayWidth / totalWidth;
		if (numPage > 1) {
			this.setState({
				nextPageIcon: true,
				isVisiblePage: true, //是否显示分页
			});
		} else {
			this.setState({
				isVisiblePage: false, //不显示分页
			});
		}
	};

	handleSetActive = (last, to) => {
		//解决个别windows电脑选中最后一个tab滚动时清不掉选中状态
		const $ulChildNodes = this.refs.refUl && this.refs.refUl.childNodes;
		const $lastLink = $ulChildNodes && [...$ulChildNodes].find((item, i, arr) => i === arr.length - 1);
		if(last && to !== last) {
			const $last = $lastLink && $lastLink.querySelector('a');
			if($lastLink && $last && $last.classList.contains(tabActiveClass)) {
				$last.classList.remove(tabActiveClass);
			}
		}
	}

	//dom渲染后用来监测页面分页状态的显示
	componentDidMount() {
		window.addEventListener("resize", this.screenChange);
		//延时加载更改状态
		setTimeout(() => {
			if(this.refs.refTabs && this.refs.refUl) {
				let totalWidth = this.refs.refTabs.offsetWidth;
				let displayWidth = this.refs.refUl.offsetWidth;
				let numPage = displayWidth / totalWidth;
				if (numPage > 1) {
					this.setState({
						nextPageIcon: true,
						isVisiblePage: true, //是否显示分页
					});
				} else {
					this.setState({
						isVisiblePage: false, //不显示分页
					});
				}
			}
		}, 1500);
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.screenChange);
	}

	//点击link设置选中
	handleLinkClick = e => {
		// if(!this.props.editable) {
        let evt = cloneDeep(e);
		const preState = cloneDeep(this.state);
		
        //解决点击link有时不会高亮
        setTimeout(() => {
            let $links = this.refs.refUl.querySelectorAll('a');
            $links.forEach(a => a.classList.remove(tabActiveClass))
            evt.target.classList.add(tabActiveClass)

			//点击第二页tab有时会切换到第一页，需要重新setState强制变成第二页
			if(preState.times > 1) {
				this.setState(preState);
			}
        }, SCROLL_DURATION + 50);
		// }
	}
	render() {
		const { editable } = this.props;
		return (
			<div className={editable ? 'content-anchor' : 'tabs-layout'} ref='refTabs'>
				<div className='tabs-page'>
					<ul ref='refUl' className={this.state.nextPage ? "n-tabs " : "n-tabs"}>
						{this.createTabsLink()}
					</ul>
				</div>
				{
					!editable && (
						<div className='tabs-icon'>
							<span
								onClick={this.previousPageGroup}
								className={this.state.nowPosition ? "" : "iconfontColor"}
								style={
									this.state.isVisiblePage
										? { visibility: "visible" }
										: { visibility: "hidden" }
								}>
								<i className='iconfont icon-jiantouzuo' />
							</span>
							<span
								onClick={this.nextPageGroup}
								className={this.state.nextPageIcon ? "" : " iconfontColor"}
								style={
									this.state.isVisiblePage
										? { visibility: "visible" }
										: { visibility: "hidden" }
								}>
								<i className='iconfont icon-jiantouyou' />
							</span>
						</div>
					)
				}
			</div>
		);
	}
}
export default connect(
	(state) => ({
		groups: state.gridLayoutData.groups,
	}),
	{}
)(TabsLink);
